<section class="mobile-phone-details">
  <div class="mobile-info-section">
    <app-mobilephone-info
      [isLoadingMobilePhoneOffering]="isLoadingMobilePhoneOffering"
      [isManualRegistration]="isManualRegistration"
      [mobilePhoneVariant]="mobilePhoneVariant ?? selectedVariant"
      [phoneName]="mobileProductInCart?.name || form.controls.productName?.value || defaultName"
    />
  </div>
  <app-ice-card>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="mobile-phone-details-wrapper">
        @if (!isManualRegistration) {
          <app-mobilephone-variant-options
            [mobilePhoneGroupVariants]="groupVariants"
            [selectedVariant]="selectedVariant"
            (variantChanged)="onColorVariantChanged($event)"
          />
        }
        @if (isManualRegistration) {
          <app-equipment-identification
            [equipmentVariant]="EquipmentVariant.MobilePhone"
            (fetchingProductData)="isLoadingMobilePhoneOffering = $event"
          />
        }
        <app-mobilephone-payment-details
          [allVoiceProducts]="allVoiceProducts"
          [canOnlySellMobilePhoneWithSubscription]="canOnlySellMobilePhoneWithSubscription()"
          [canSellCellPhoneWithoutSubscription]="canSellCellPhoneWithoutSubscription"
          [canSellHardwareWithLogistics]="canSellHardwareWithLogistics"
          [existingProductsAvailableForEquipmentUpgrade]="
            isEquipmentUpgradeUpgrade
              ? existingProductsAvailableForEquipmentUpgradeUpgrade()
              : existingProductsAvailableForEquipmentUpgrade()
          "
          [hasMobilBytteProductInCart]="hasMobilBytteProductInCart"
          [isEquipmentUpgradeEnabled]="isEquipmentUpgradeEnabled()"
          [isEquipmentUpgradePreCheckSuccessful]="isEquipmentUpgradePreCheckSuccessful()"
          [isManualRegistration]="isManualRegistration"
          [isMobilBytteBytte]="isEquipmentUpgradeUpgrade"
          [mobilePhoneVariant]="mobilePhoneVariant"
          (equipmentUpgradeNewOfferingChanged)="onEquipmentUpgradeNewOfferingChanged($event)"
          (paymentTypeChanged)="onPaymentTypeChanged($event)"
        />
        @if (form.get(MobilePhoneFormControls.IsSubscriptionUpgrade).enabled) {
          <app-equipment-voice-number-type
            [equipmentPaymentType]="form.get(MobilePhoneFormControls.PaymentType)?.value"
            [existingProductsAvailableForEquipmentUpgrade]="
              isEquipmentUpgradeUpgrade
                ? existingProductsAvailableForEquipmentUpgradeUpgrade()
                : existingProductsAvailableForEquipmentUpgrade()
            "
            [existingVoiceProducts]="existingVoiceProducts()"
            [isSubscriptionLimitReached]="isSubscriptionLimitReached()"
            [productInCart]="mobileProductInCart"
            (getExistingVoiceProductsDetails)="onGetExistingVoiceProductsDetails()"
          />
        }
        @if (form.get(MobilePhoneFormControls.IsSoldInShop).enabled && !isManualRegistration) {
          <app-mobilephone-delivery-type
            [canSellHardwareWithLogistics]="canSellHardwareWithLogistics"
            [isManualRegistration]="isManualRegistration"
            [mobilePaymentType]="form.get(MobilePhoneFormControls.PaymentType)?.value"
          />
        }
        @if (canSellMobileInsurance()) {
          <app-mobilephone-insurance-options
            [allVoiceProducts]="allVoiceProducts"
            [mobilePhoneVariant]="mobilePhoneVariant"
            [mobileProductId]="mobileProductInCart?.id"
          />
        }
        <div class="buttons">
          @if (!isManualRegistration) {
            <div>
              <app-ice-button
                color="secondary"
                testId="pick-different-phone-button"
                width="100%"
                (click)="backToSearch.emit()"
              >
                Velg en annen telefon
              </app-ice-button>
            </div>
          }
          <div>
            <app-ice-button
              color="primary"
              testId="mobile-phone-continue-button"
              type="submit"
              width="100%"
              [disabled]="form.invalid || (mobileProductInCart && isFormUnchanged) || isValidatingImei()"
              [isLoading]="isSubmitted"
            >
              Fortsett
            </app-ice-button>
          </div>
        </div>
      </div>
    </form>
  </app-ice-card>
</section>
